import CommentsList from '../Notes/NoteDetails/NotesCommentsList';
import CommentItem from './CommentItem';

export { CommentsList, CommentItem };
